import React, { useEffect } from "react";
import ReactDOM from "react-dom";

import "./assets/css/style.css";

interface ModalProps {
  message: string;
  title?: string;
  type?: string;
  className?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onOpen?: Function;
  onClose?: Function;
  onOk?: Function;
  onCancel?: Function;
}

export class ModalTypes {
  static Alert: string = "alert";
  static Success: string = "success";
  static Error: string = "error";
  static Default: string = "";
  static Types = ["alert", "success", "error"];
}

export class SetModal {
  static FromResponse(response: any, onClose?: Function) {
    const title: string = response.status === 200 ? "Confirmation" : "Error";
    const type: string = response.status === 200 ? ModalTypes.Success : ModalTypes.Error;
    const message: string = response?.message ?? response?.Message;
    return <Modal title={title} message={message} type={type} onClose={onClose} />;
  }
}

const Modal: React.FC<ModalProps> = ({
  message,
  title,
  type,
  className,
  confirmLabel,
  cancelLabel,
  onOpen,
  onClose,
  onOk,
  onCancel
}) => {
  const el = document.createElement("div");
  const isConfirm = Boolean(onOk);

  const closeModal = () => {
    document.body.removeChild(el);
    if (onClose)
      onClose();
    //history.push({ pathname: "/empty" });
    //history.goBack();
  };

  const confirm = () => {
    document.body.removeChild(el);
    if (onOk)
      onOk();
  };

  const cancel = () => {
    document.body.removeChild(el);
    if (onCancel)
      onCancel();
  };

  useEffect(() => {
    document.body.appendChild(el);
  }, []);

  type = ModalTypes.Types.includes(type!) ? type : ModalTypes.Default;

  return ReactDOM.createPortal(
    <div className="alphaBg">
      <div className={`modal ${type}${className ? ` ${className}` : ""}`}>
        <button
          className="modal__close close"
          onClick={() => {
            isConfirm ? cancel() : closeModal();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <path d="M13.7.3c-.4-.4-1-.4-1.4 0L7 5.6 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4L5.6 7 .3 12.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3L7 8.4l5.3 5.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L8.4 7l5.3-5.3c.4-.4.4-1 0-1.4z" />
          </svg>{" "}
        </button>
        <h3 className="modal__title">{title}</h3>
        <p className="modal__text">{message}</p>
        {/*Colors: buttons--gray; button--blue; button--red*/}
        {isConfirm ? (
          <div className="modal__buttons">
            <button className="button button--blue modal__button" onClick={confirm}>
              {confirmLabel || "Confirm"}
            </button>
            <button className="button button--gray modal__button" onClick={cancel}>
              {cancelLabel || "Cancel"}
            </button>
          </div>
        ) : (
          <div
            className="modal__buttons"
            onClick={() => {
              closeModal();
            }}
          >
            <button className="button button--blue modal__button">OK</button>
          </div>
        )}
      </div>
    </div>,
    el
  );
};

export default Modal;
